import './utils/arrayFrom_poly';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, compose } from 'redux';
import { Provider } from 'react-redux';
import persistState from 'redux-localstorage';
import { Router, Route, IndexRoute, Redirect,  browserHistory } from 'react-router';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
import * as SmoothScroll from './utils/smoothScroll';
import * as CartHelper from './utils/cartHelper';
import WebFont from 'webfontloader/webfontloader';
import cards from './reducers/Cards';
import formValues from './reducers/Form';
import Home from './pages/Home';
import App from './App';
import config from './config';
import './stylesheets/app.scss';

/**
*  Create redux stores
*
*/
if(CartHelper.isCartOutdated(config.eshop.maximumCartPersistHours)) {
	localStorage.removeItem('redux');
}
const enhancer = compose(persistState());
//const enhancer = CartHelper.isCartOutdated(config.eshop.maximumCartPersistHours) ? {} : compose(persistState());

let store = createStore(
	combineReducers({
		cards,
		formValues,
		routing: routerReducer
	}),
	enhancer
);

/**
*  Load Webfont
*
*/
WebFont.load(config.webfont);

/**
*  React render router with history
*
*/

function handleRouterUpdate() {
	SmoothScroll.scrollToTop();
}
const history = syncHistoryWithStore(browserHistory, store);
ReactDOM.render((
	<Provider store={store}>
		<Router history={history} onUpdate={handleRouterUpdate}>
			<Route path="/" component={App}>
				<IndexRoute component={Home} />
				<Redirect from="*" to="/" />
			</Route>
		</Router>
	</Provider>
), document.getElementById('root'));

Provider.childContextTypes = {
	store: React.PropTypes.object,
	router: React.PropTypes.object
};


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/